var plugin_rtlignore_default = {
  "alignLeft": "Lxph4",
  "textWrapNowrap": "_3pwKy",
  "alignRight": "PA1Un",
  "alignCenter": "n5dZy",
  "sizeFullWidth": "HmUib",
  "renderedInTable": "_2ITI-",
  "sizeOriginal": "qxYoF",
  "sizeContent": "z7ydy",
  "sizeSmall": "_3zdRB",
  "sizeSmallCenter": "S6Doe",
  "flex": "_4u7es",
  "atomic": "-vHqt",
  "embed": "_12xDG",
  "horizontalScrollbar": "vWIoW",
  "pluginContainerMobile": "wNKhL"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
